import { Box, Flex } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import { FontFamily } from '@common/theming/Fonts';
import { AccreditationStatus, InvestorAccount } from '@services/appsync/types';
import * as React from 'react';
import { TextBlock, TextBlockProps } from '../components/TextBlock';

type InvestorCardProps = {
  investorAccount: InvestorAccount;
};

const CustomerEmail: React.FC<{ email: string; accredited: boolean }> = ({ email, accredited }) => {
  const emailCharacterBreakpoint = 29;
  const splitEmail = email?.split('@');
  const shouldStackEmail = email && email.length > emailCharacterBreakpoint && splitEmail && splitEmail.length > 1;

  const textProps: TextBlockProps = {
    background: accredited ? 'linear-gradient(90deg, #D3D5C8 20.83%, #8B8469 48.96%, #D2D3CB 78.13%)' : 'transparent',
    backgroundClip: accredited ? 'text' : 'initial',
    color: accredited ? 'transparent' : 'black',
    fontFamily: FontFamily.LIBRE_FRANKLIN_REGULAR,
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '1.2px',
    mt: accredited ? '6px' : '7px',
    textAlign: 'center',
    w: 'full',
  };

  return shouldStackEmail ? (
    <Flex flexDir={'column'}>
      <TextBlock {...textProps}>{splitEmail[0]}</TextBlock>
      <TextBlock {...textProps}>{`@${splitEmail[1]}`}</TextBlock>
    </Flex>
  ) : (
    <TextBlock {...textProps}>{email}</TextBlock>
  );
};

export const InvestorCard: React.FC<InvestorCardProps> = ({ investorAccount }) => {
  const accredited = investorAccount?.accreditation_self?.status === AccreditationStatus.APPROVED;
  return accredited ? (
    <Box p="6px">
      <Flex borderRadius={'6px'} bgColor={'black'} w="full">
        <Flex py="16px" flexDir={'column'} borderRadius={'6px'} flex={1} m="4px" border="0.5px solid #858681">
          <TextBlock
            background="linear-gradient(90deg, #D3D5C8 20.83%, #8B8469 48.96%, #D2D3CB 78.13%)"
            w="full"
            color="transparent"
            textAlign={'center'}
            backgroundClip="text"
            fontWeight={'600'}
            fontFamily={FontFamily.LIBRE_FRANKLIN_REGULAR}
            fontSize={'7px'}
            letterSpacing={'4px'}>
            ACCREDITED INSIDER
          </TextBlock>
          <Image mt="7px" h="28px" image="keyhole" />
          <CustomerEmail email={investorAccount.email ?? ''} accredited={accredited} />
        </Flex>
      </Flex>
    </Box>
  ) : (
    <Box p="6px">
      <Flex
        borderRadius={'6px'}
        background="radial-gradient(151.63% 151.37% at 51.75% 6.68%, #D8DBDE 14.33%, #A9ADB0 59.41%)"
        w="full">
        <Flex py="16px" flexDir={'column'} borderRadius={'6px'} flex={1} m="4px" border="0.5px solid black">
          <TextBlock
            w="full"
            textAlign={'center'}
            fontWeight={'600'}
            fontFamily={FontFamily.LIBRE_FRANKLIN_REGULAR}
            fontSize={'7px'}
            letterSpacing={'4px'}>
            WEALTH BUILDER
          </TextBlock>
          <Image mt="10px" h="24px" image="wealth-builder" />
          <CustomerEmail email={investorAccount.email ?? ''} accredited={accredited} />
        </Flex>
      </Flex>
    </Box>
  );
};
